import { SignInForm } from '@/pages/auth/sign-in/SignInForm';

// ----------------------------------------------------------------------

const SignInPage = () => <SignInForm />;

export default SignInPage;
